/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostoneloginaccountsPostOneLoginAccountsRequestBody
 */
export interface JumboPostoneloginaccountsPostOneLoginAccountsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostoneloginaccountsPostOneLoginAccountsRequestBody
     */
    clientID: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostoneloginaccountsPostOneLoginAccountsRequestBody
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostoneloginaccountsPostOneLoginAccountsRequestBody
     */
    orgURL: string;
}

/**
 * Check if a given object implements the JumboPostoneloginaccountsPostOneLoginAccountsRequestBody interface.
 */
export function instanceOfJumboPostoneloginaccountsPostOneLoginAccountsRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientID" in value;
    isInstance = isInstance && "clientSecret" in value;
    isInstance = isInstance && "orgURL" in value;

    return isInstance;
}

export function JumboPostoneloginaccountsPostOneLoginAccountsRequestBodyFromJSON(json: any): JumboPostoneloginaccountsPostOneLoginAccountsRequestBody {
    return JumboPostoneloginaccountsPostOneLoginAccountsRequestBodyFromJSONTyped(json, false);
}

export function JumboPostoneloginaccountsPostOneLoginAccountsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostoneloginaccountsPostOneLoginAccountsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientID': json['clientID'],
        'clientSecret': json['clientSecret'],
        'orgURL': json['orgURL'],
    };
}

export function JumboPostoneloginaccountsPostOneLoginAccountsRequestBodyToJSON(value?: JumboPostoneloginaccountsPostOneLoginAccountsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientID': value.clientID,
        'clientSecret': value.clientSecret,
        'orgURL': value.orgURL,
    };
}

